import { useEffect, useState } from 'react';

import services from 'services';

const useFullscreen = () => {
  const [isFullscreenEnabled, setFullscreenEnabled] = useState<boolean>(services.appFrame.viewport.isFullScreen);
  useEffect(() => {
    return services.appFrame.viewport.onFullScreenChange((fullscreenEnabled: boolean) => {
      setFullscreenEnabled(fullscreenEnabled);
    });
  }, []);

  return isFullscreenEnabled;
};

export default useFullscreen;
